export default __webpack_public_path__ + "static/media/sample3.44ba3c0b.webp";